<template>
    <v-btn
        depressed
        :small="!medium"
        :color="color"
        :outlined="outlined"
        :block="block"
        :class="color ? 'ml-2 white--text' : 'ml-2'"
        :loading="loading"
        :disabled="disabled"
        @click="press"
    >
        {{ text }}
        <v-icon right>{{ icon }}</v-icon>
    </v-btn>
</template>

<script>
export default {
    name: "WBtn",
    props: {
        loading: Boolean,
        disabled: Boolean,
        outlined: Boolean,
        block: Boolean,
        medium: Boolean,
        color: String,
        text: String,
        icon: String
    },
    emits: ["press"],
    setup(props, {emit}) {
        function press() {
            emit("press");
        }
        
        return {
            press
        };
    }
};
</script>

<style scoped></style>